import * as React from 'react';
import { connect } from 'react-redux';
import { fetchUsuario, editUsuario, resetUsuario, fetchUsuarios, userTypeIds, updateListUsuarios } from '../../actions/usuariosActions';
import { fetchSeller } from '../../actions/sellersActions';
import { postSearchTokenUsuario, editUser, putActivarUsuario, putPausarUsuario, deshabilitarMfaUsuarioApi, obtenerTiposUsuarioApi } from '../../api/axios';
import { toast } from 'react-toastify';
import { isEmail } from '../../utilities/formatString';
import PasswordValidation from './PasswordValidation';
import GoBackArrow from '../General/GoBackArrow';
import Auth from '../../auth';
import { encryptPassword } from '../../utilities/encryptPassword';
import { withNavigation } from '../General/withNavigation';
import UserSidebarItems from './UserSidebarItems';
import { Modal, Button } from 'react-bootstrap';

class UserEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            usuarioError: false,
            password: "",
            confirmPassword: "",
            passValidation: false,
            showPassword: false,
            showConfirmPassword: false,
            hiddenItems: [],
            soloLectura: false,
            activo: true,
            showSpinner: false,
            localTipoUsuario: 0,
            localIdUsuario: 0,
            token: '',
            limiteCaracteresExcedido: false,
            tiposUsuario: [],
            showConfirmModal: false,
            showMfaConfirmModal: false
        };
        this.emailUsuarioInputRef = React.createRef();
        this.tiposUsuario = [
            { value: 1, label: "Category" },
            { value: 6, label: "Solo Lectura" },
            { value: 7, label: "Proveedor" }
        ];
    };

    componentDidMount() {
        const { usuario, match } = this.props;
        const userIdFromUrl = match?.params?.id;
        const { isResetMode, username } = this.props.location?.state || {};

        if (userIdFromUrl && userIdFromUrl != "0") {
            if (!usuario || usuario.idUsuario != userIdFromUrl || JSON.stringify(usuario) === "{}" || JSON.stringify(usuario) === "[]") {
                this.props.fetchUsuario({ idUsuario: userIdFromUrl });
            } else {
                this.initializeUser(usuario);
            }
        } else if (userIdFromUrl == "0") {
            this.props.resetUsuario();
            this.initializeUser({
                idUsuario: 0,
                identificadores: [],
                soloLectura: false,
                baja: false,
                tipoUsuario: 0
            });
        } else if (isResetMode && username) {
            this.props.fetchUsuario({ usuario: username });
        } else {
            if ((JSON.stringify(usuario) === "{}" || JSON.stringify(usuario) === "[]") && !isResetMode) {
                this.goBack();
            } else {
                this.initializeUser(usuario);
            }
        }
        this.fetchTiposUsuario();
    }

    fetchTiposUsuario = () => {
        obtenerTiposUsuarioApi().then(res => {
            if (res.data && Array.isArray(res.data)) {
                this.setState({ tiposUsuario: res.data });
            } else if (Array.isArray(res)) {
                this.setState({ tiposUsuario: res });
            }
        }).catch(err => {

        });
    }

    componentDidUpdate(prevProps) {
        const userIdFromUrl = this.props.match?.params?.id;

        // If in Create Mode (ID 0), do not react to props.usuario updates to prevent stale data injection
        if (userIdFromUrl === "0") return;

        if (this.props.usuario && this.props.usuario !== prevProps.usuario && JSON.stringify(this.props.usuario) !== "{}" && JSON.stringify(this.props.usuario) !== "[]") {
            this.initializeUser(this.props.usuario);
        }
    }

    initializeUser = (usuario) => {
        this.setState({
            hiddenItems: usuario.identificadores || [],
            soloLectura: usuario.soloLectura,
            activo: !usuario.baja,
            localTipoUsuario: usuario.tipoUsuario,
            localIdUsuario: usuario.idUsuario
        }, () => {
            this.fetchTokenUsuario();
            if (this.emailUsuarioInputRef.current) {
                this.emailUsuarioInputRef.current.focus();
            }
        });
    }

    changePassword = (e) => {
        const { value } = e.target;

        if (value.length > 12) {
            if (!this.state.limiteCaracteresExcedido) {
                toast.warn("Excede los 12 caracteres, verifique");
                this.setState({ limiteCaracteresExcedido: true });
            }
            return;
        }

        this.setState({
            password: value,
            limiteCaracteresExcedido: false
        });
    }

    handlePassValidation = (isSuccess) => {
        this.setState({ passValidation: isSuccess });
    };

    confirmPassword = (e) => {
        const { value } = e.target;
        this.setState({
            usuarioError: value !== this.state.password,
            confirmPassword: value
        });
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        const usuarioActualizado = {
            ...this.props.usuario,
            [event.target.name]: event.target.value
        };
        this.props.editUsuario(usuarioActualizado);
    };


    updateHiddenItems = (hiddenItems) => {
        this.setState({ hiddenItems });
    };

    onSwitchChange = () => {
        const valueEstado = !this.state.soloLectura;

        this.setState({ soloLectura: valueEstado, didEdit: true });

        const usuarioActualizado = {
            ...this.props.usuario,
            soloLectura: valueEstado
        };

        this.props.editUsuario(usuarioActualizado);
    };


    onSwitchStateChange = () => {
        this.setState({ showConfirmModal: true });
    };

    handleConfirmSwitch = () => {
        const { activo, localIdUsuario } = this.state;
        const nuevoEstado = !activo; // Si está activo (true), el nuevo estado es falso (pausar). Si está inactivo (false), el nuevo estado es verdadero (activar).

        this.setState({
            showConfirmModal: false,
            activo: nuevoEstado,
            didEdit: true,
            showSpinner: true
        });

        const usuarioActualizado = {
            ...this.props.usuario,
            activo: nuevoEstado
        };

        this.props.editUsuario(usuarioActualizado);

        let requestPromise;

        // Si actualmente está activo (activo=true), queremos PAUSAR (apagar).
        // Si actualmente está inactivo (activo=false), queremos ACTIVAR (encender).
        if (activo) {
            // El estado actual es ON, el usuario hizo clic para apagar -> Llamar a Pausar
            requestPromise = putPausarUsuario(localIdUsuario);
        } else {
            // El estado actual es OFF, el usuario hizo clic para encender -> Llamar a Activar
            requestPromise = putActivarUsuario(localIdUsuario);
        }

        requestPromise
            .then(() => {
                toast.success("Estado editado exitosamente");
                // NO volvemos atrás, solo actualizamos el estado.
            })
            .catch(err => {
                // Revertir estado en caso de error
                this.setState({ activo: activo });
                if (err.response?.data?.errores) {
                    err.response.data.errores.forEach(error => toast.error(error));
                } else {
                    toast.error("No pudo editarse");
                }
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    handleCloseModal = () => {
        this.setState({ showConfirmModal: false });
    };

    handleTipoUsuarioChange = (selectedOption) => {
        const nuevoTipo = selectedOption.value;
        this.setState({
            localTipoUsuario: nuevoTipo,
            didEdit: true
        });

        const usuario = {
            ...this.props.usuario,
            tipoUsuario: nuevoTipo
        };
        this.props.editUsuario(usuario);
    };


    onSubmit = async (event) => {
        event.preventDefault();

        const { userType } = this.props;
        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;

        // Use props usage but default to empty/0 if missing in Reset Mode
        const { email, nombreUsuario, idUsuario = (isResetMode ? 0 : undefined), idSeller, soloLectura, activo } = this.props.usuario || {};
        const { localTipoUsuario } = this.state;

        if (!isResetMode && !isEmail(email)) {
            if (email === "") {
                toast.warn("Ingrese un e-mail de usuario");
                return;
            }
            toast.warn("Mail incorrecto");
            return;
        }

        if (nombreUsuario === "") {
            toast.warn("Ingrese un nombre de usuario");
            return;
        }

        if (!this.state.passValidation) {
            toast.warn("La contraseña no cumple con los requisitos");
            return;
        }

        if (idUsuario === this.props.idUsuario && this.state.usuarioError) {
            toast.warn("Las contraseñas no coinciden");
            return;
        }

        const { password, hiddenItems } = this.state;


        // Determine effective ID and fallback values for Reset Mode
        let effectiveId = idUsuario;
        let effectiveEmail = email;
        let effectiveUsuario = nombreUsuario;

        if (isResetMode && (!effectiveId || effectiveId === 0)) {
            // Fallback to session ID if available
            if (this.props.idUsuario && this.props.idUsuario > 0) {
                effectiveId = this.props.idUsuario;
            }
            // Fallback to location state username if props are empty
            if (!effectiveEmail && this.props.location?.state?.username) {
                effectiveEmail = this.props.location.state.username;
            }
            if (!effectiveUsuario && this.props.location?.state?.username) {
                effectiveUsuario = this.props.location.state.username;
            }
        }

        let userUpdated = {
            idUsuario: effectiveId,
            idSeller: idSeller,
            email: effectiveEmail,
            usuario: effectiveUsuario,
            soloLectura: soloLectura,
            identificadores: hiddenItems,
            tipoUsuario: localTipoUsuario,
            baja: !this.state.activo,
            modulos: []
        };

        if (password && password.length > 0) {
            userUpdated.password = encryptPassword(password);
        } else {
            userUpdated.password = "";
        }

        // Only unset if we still don't have an ID (which shouldn't happen if session is active)
        if (isResetMode && (!effectiveId || effectiveId === 0)) {
            userUpdated.email = undefined;
            userUpdated.usuario = undefined;
        }

        this.setState({ showSpinner: true });

        try {
            await editUser(userUpdated);
            toast.success("Usuario editado exitosamente");

            toast.success("Usuario editado exitosamente");

            try {
                if (this.props.usuarios && Array.isArray(this.props.usuarios)) {
                    this.props.updateListUsuarios(this.props.usuarios, userUpdated);
                }
            } catch (updateError) {

            }


            this.props.userType.isResetPassword ? this.onLogout() : this.goBack();

        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No pudo editarse");
            }
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    fetchTokenUsuario = () => {
        const { userType } = this.props;
        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;

        if (isResetMode) return;

        const { localIdUsuario } = this.state;
        const { usuario } = this.props;

        // Fallback: try to get ID from props if state is empty
        const idToUse = localIdUsuario || usuario?.idUsuario;

        if (!idToUse || idToUse === "0" || isNaN(Number(idToUse)) || Number(idToUse) <= 0) {
            return;
        }

        const data = {
            IdUsuario: Number(idToUse)
        };

        const req = postSearchTokenUsuario(data);
        req.then((res) => {
            if (res.data) {
                this.setState({ token: res.data.token });
            }
        }).catch((err) => {

        });
    }

    onLogout = () => {
        Auth.logout();
        this.props.navigate("/login");
    }

    goBack = () => {
        this.props.resetUsuario()
        window.history.go(-1);
    }

    togglePasswordVisibility = () => {
        if (this.state.password.length === 0) {
            toast.warn("Ingrese contraseña");
            return;
        }
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));
    };

    toggleConfirmPasswordVisibility = () => {
        if (this.state.confirmPassword.length === 0) {
            toast.warn("Confirme contraseña");
            return;
        }
        this.setState(prevState => ({ showConfirmPassword: !prevState.showConfirmPassword }));
    };

    handleDisableMfa = () => {
        this.setState({ showMfaConfirmModal: true });
    };

    handleCloseMfaModal = () => {
        this.setState({ showMfaConfirmModal: false });
    };

    executeDisableMfa = () => {
        const { usuario } = this.props;
        const request = {
            IdUsuario: usuario.idUsuario
        };

        this.setState({ showSpinner: true, showMfaConfirmModal: false });

        deshabilitarMfaUsuarioApi(request)
            .then(() => {
                toast.success("MFA deshabilitado correctamente");
                // Actualizar el estado del usuario para reflejar MFA deshabilitado
                const updatedUser = { ...usuario, mfaConfirmado: false };
                this.props.editUsuario(updatedUser);
            })
            .catch((error) => {
                console.error(error);
                toast.error("Error al deshabilitar MFA");
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    render() {
        const { userType } = this.props;

        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;

        const isCreateMode = this.props.match?.params?.id == "0";

        let usuario = this.props.usuario;
        const isEmpty = !usuario || JSON.stringify(usuario) === "{}" || JSON.stringify(usuario) === "[]";

        if (isEmpty && (isResetMode || isCreateMode)) {
            usuario = {
                idUsuario: 0,
                email: isResetMode ? (this.props.location?.state?.username || "") : "",
                nombreUsuario: isResetMode ? (this.props.location?.state?.username || "") : "",
                soloLectura: false,
                baja: false,
                identificadores: [],
                tipoUsuario: 0
            };
        }

        if (!userType || !usuario || JSON.stringify(usuario) === "{}") {
            return <div>Loading...</div>;
        }

        // Permitir permisos de edición para todos los usuarios
        const canEditUserItems = true;

        const rowSize = "col-12 col-sm-6";
        const colSize = (userType.isAdminMod || userType.isSellerAdmin) &&
            canEditUserItems ? "col-12" : "col-12 col-sm-6";

        const IconEye = (isHidden) => (
            <i className={`me-1 mdi mdi-eye${isHidden ? "" : "-off"} mdi-24px text-dark`} />
        );

        const switchButtonStyle = (isActive, disabled) => ({
            backgroundColor: isActive ? '#28a745' : '#e9ecef',
            color: isActive ? 'white' : '#6c757d',
            padding: '10px 25px',
            borderRadius: '30px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontWeight: '600',
            display: 'inline-block',
            userSelect: 'none',
            minWidth: '140px',
            textAlign: 'center',
            opacity: disabled ? 0.6 : 1,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            border: isActive ? 'none' : '1px solid #ced4da',
            letterSpacing: '0.5px'
        });

        return (
            <form
                autoComplete="off"
                onSubmit={this.onSubmit}
                className="container card form-horizontal form-material"
            >
                <div className="row card-body p-3">

                    <div className="col-12 mb-3 text-center">
                        {(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                            <img
                                src="/img/logo-marketplace-megatone.png"
                                alt="MegaMarket"
                                style={{ maxWidth: '200px', marginBottom: '20px' }}
                            />
                        )}
                        {!(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                            <div className="d-flex align-items-center">
                                <div
                                    onClick={() => {
                                        this.props.resetUsuario();
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <GoBackArrow />
                                </div>
                                <h4 className="card-title d-block d-sm-inline ms-2">
                                    Editar usuario
                                </h4>
                            </div>
                        )}
                    </div>

                    <div className={rowSize}>
                        <div className="row">

                            {!(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                <>
                                    <div className={colSize}>
                                        <div className="form-group">
                                            <label>Email Usuario</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={usuario.email || ""}
                                                onChange={this.myChangeHandler}
                                                placeholder="usuario@dominio.com"
                                                name="email"
                                                autoComplete="off"
                                                ref={this.emailUsuarioInputRef}
                                            />
                                        </div>
                                    </div>

                                    <div className={colSize}>
                                        <div className="form-group">
                                            <label>Usuario</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={usuario.nombreUsuario || ""}
                                                onChange={this.myChangeHandler}
                                                placeholder="nombreUsuario"
                                                name="nombreUsuario"
                                                maxLength="40"
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className={colSize}>
                                <div className="form-group">
                                    <label>
                                        {userType.isResetPassword ? "Nueva contraseña" : "Contraseña"}
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={this.state.showPassword ? "text" : "password"}
                                            className="form-control"
                                            value={this.state.password}
                                            onChange={this.changePassword}
                                            autoComplete="new-password"
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-link"
                                            onClick={this.togglePasswordVisibility}
                                        >
                                            {IconEye(this.state.showPassword)}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className={colSize}>
                                <div className="form-group">
                                    <label>
                                        {userType.isResetPassword
                                            ? "Confirmar nueva contraseña"
                                            : "Confirmar contraseña"
                                        }
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={this.state.showConfirmPassword ? "text" : "password"}
                                            className={`form-control ${this.state.usuarioError ? "warning-input" : ""}`}
                                            value={this.state.confirmPassword}
                                            onChange={this.confirmPassword}
                                            maxLength="12"
                                            autoComplete="new-password"
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-link"
                                            onClick={this.toggleConfirmPasswordVisibility}
                                        >
                                            {IconEye(this.state.showConfirmPassword)}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 d-inline">
                                <label htmlFor="passwordValidation">Requisitos contraseña</label>
                                <PasswordValidation
                                    password={this.state.password}
                                    isValidPassword={this.handlePassValidation}
                                />
                            </div>

                            {/* Campo Token - solo visible para Category, AdminMod, SellerAdmin */}
                            {!(userType.isResetPassword || this.props.location?.state?.isResetMode) &&
                                (this.props.currentUserType === userTypeIds.isCategory ||
                                    this.props.currentUserType === userTypeIds.isAdminMod ||
                                    this.props.currentUserType === userTypeIds.isSellerAdmin) && (
                                    <div className={colSize}>
                                        <div className="form-group">
                                            <label>Token</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={this.state.token || ""}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                )}

                            <div className="col-12">
                                <hr className="my-4" />
                            </div>

                            {/* Dropdown Tipo de Usuario */}
                            {(this.props.currentUserType === userTypeIds.isCategory || this.props.currentUserType === userTypeIds.isAdminMod) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                <div className="col-12 col-sm-6 mt-2">
                                    <div className="form-group">
                                        <label className="control-label font-weight-bold text-muted text-uppercase small" style={{ letterSpacing: '1px' }}>Tipo Usuario</label>
                                        <div style={{ position: 'relative' }}>
                                            <select
                                                className="form-control form-select shadow-sm"
                                                style={{
                                                    height: '48px',
                                                    borderRadius: '8px',
                                                    appearance: 'none',
                                                    WebkitAppearance: 'none',
                                                    MozAppearance: 'none',
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #ced4da',
                                                    paddingRight: '40px',
                                                    fontSize: '1rem',
                                                    color: '#495057',
                                                    cursor: 'pointer'
                                                }}
                                                value={this.state.localTipoUsuario || ""}
                                                onChange={(e) => this.handleTipoUsuarioChange({ value: parseInt(e.target.value) })}
                                                name="localTipoUsuario"
                                            >
                                                <option value="">Seleccione...</option>
                                                {this.state.tiposUsuario && this.state.tiposUsuario.map(tipo => (
                                                    <option key={tipo.id} value={tipo.id}>{tipo.descripcion}</option>
                                                ))}
                                            </select>
                                            <i
                                                className="mdi mdi-chevron-down"
                                                style={{
                                                    position: 'absolute',
                                                    right: '15px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    pointerEvents: 'none',
                                                    color: '#6c757d',
                                                    fontSize: '20px'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {(this.props.currentUserType === userTypeIds.isCategory || this.props.currentUserType === userTypeIds.isAdminMod) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                <div className="col-12 col-sm-6 mt-2">
                                    <div className="form-group">
                                        <label className="control-label font-weight-bold d-block mb-2 text-muted text-uppercase small" style={{ letterSpacing: '1px' }}>Usuario Activo</label>
                                        <div
                                            onClick={this.onSwitchStateChange}
                                            style={switchButtonStyle(this.state.activo, false)}
                                            className="d-flex align-items-center justify-content-center shadow-sm"
                                        >
                                            <i className={`mdi ${this.state.activo ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'} me-2`} style={{ fontSize: '1.2rem' }}></i>
                                            <span>{this.state.activo ? "ACTIVO" : "INACTIVO"}</span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Estado MFA y Botón Deshabilitar */}
                            {(this.props.currentUserType === userTypeIds.isCategory || this.props.currentUserType === userTypeIds.isAdminMod || userType.isSellerAdmin) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                <div className="col-12 mt-4">
                                    <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                        <div className="card-body d-flex align-items-center justify-content-between p-3">
                                            <div>
                                                <h6 className="mb-1 font-weight-bold text-dark">Autenticación de Dos Factores (MFA)</h6>
                                                <p className="mb-0 text-muted small">Gestiona la seguridad adicional de la cuenta.</p>
                                            </div>
                                            <div>
                                                {usuario.mfaConfirmado ? (
                                                    <div className="d-flex align-items-center">
                                                        <span className="badge bg-success me-3 px-3 py-2 rounded-pill">MFA Activo</span>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger btn-sm rounded-pill px-3"
                                                            onClick={this.handleDisableMfa}
                                                            disabled={this.state.showSpinner}
                                                        >
                                                            Deshabilitar
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <span className="badge bg-secondary px-3 py-2 rounded-pill">MFA Inactivo</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Columna de Permisos */}
                    {canEditUserItems && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                        <div className="col-12 col-sm-6">
                            <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '8px' }}>
                                <div className="card-header bg-white border-bottom-0 pt-4 pb-2">
                                    <h5 className="mb-0 font-weight-bold text-dark">Permisos de Acceso</h5>
                                </div>
                                <div className="card-body">
                                    <UserSidebarItems
                                        tipoUsuario={this.state.localTipoUsuario}
                                        previousHiddenItems={this.state.hiddenItems}
                                        updateHiddenItems={this.updateHiddenItems}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                </div>

                <div className="card-footer bg-white border-top-0 text-end pb-4 pe-4">
                    {!(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                        <button
                            type="button"
                            className="btn btn-light text-muted me-3 px-4 rounded-pill font-weight-bold"
                            onClick={this.goBack}
                            style={{ border: '1px solid #e9ecef' }}
                        >
                            Cancelar
                        </button>
                    )}
                    <button
                        type="submit"
                        className="btn btn-primary px-5 rounded-pill font-weight-bold shadow-sm"
                        disabled={this.state.showSpinner}
                        style={{ background: 'linear-gradient(45deg, #007bff, #0056b3)', border: 'none' }}
                    >
                        {this.state.showSpinner ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
                        Guardar Cambios
                    </button>
                </div>

                <Modal show={this.state.showConfirmModal} onHide={this.handleCloseModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.activo ? "Desactivar Usuario" : "Activar Usuario"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Estás seguro de que deseas {this.state.activo ? "desactivar" : "activar"} este usuario?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModal}>
                            Cancelar
                        </Button>
                        <Button variant={this.state.activo ? "danger" : "success"} onClick={this.handleConfirmSwitch}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showMfaConfirmModal} onHide={this.handleCloseMfaModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Deshabilitar MFA</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Estás seguro de que deseas deshabilitar la autenticación de dos factores para este usuario?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseMfaModal}>
                            Cancelar
                        </Button>
                        <Button variant="danger" onClick={this.executeDisableMfa}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </form >
        );
    }
}



const mapStateToProps = state => ({
    usuario: state.usuarios.usuario,
    usuarios: state.usuarios.usuarios,
    userType: state.general.userType,
    idUsuario: state.general.idUsuario,
    currentUserType: state.general.tipoUsuario
});

export default withNavigation(connect(mapStateToProps, {
    fetchUsuario, editUsuario, resetUsuario, fetchUsuarios, fetchSeller, updateListUsuarios
})(UserEdit));
